import ProjectApi from '@apis/project/ProjectApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const STALE_TIME = 100000;

const projectKeys = createQueryKeys('project', {
    list: () => ({
        queryKey: ['list'],
        queryFn: () => ProjectApi.getProjects(),
    }),
    detail: () => ({
        queryKey: ['detail'],
        queryFn: () => ProjectApi.getProject(),
    }),
    testShops: () => ({
        queryKey: ['testShops'],
        queryFn: () => ProjectApi.getTestShops(),
    }),
});

const projectQueries = {
    ...projectKeys,
    list: () => ({
        ...projectKeys.list(),
        staleTime: STALE_TIME,
    }),
    detail: () => ({
        ...projectKeys.detail(),
        staleTime: STALE_TIME,
    }),
    testShops: () => ({
        ...projectKeys.testShops(),
        staleTime: STALE_TIME,
    }),
};

export default projectQueries;
